/**
 * GA4 measurement ID from env. Never hardcode a G- value in the repo.
 * Runtime Fly secret GA_MEASUREMENT_ID is injected as window.__GA_MEASUREMENT_ID__
 * during SSR so the client bundle does not need a baked-in ID.
 */

const normalizeGaId = value => {
  const id = typeof value === 'string' ? value.trim() : '';
  return id.indexOf('G-') === 0 ? id : null;
};

/**
 * Resolve the GA4 measurement ID from env or the SSR window hook.
 *
 * @returns {string|null}
 */
export const envGaMeasurementId = () => {
  const fromEnv = normalizeGaId(
    process.env.GA_MEASUREMENT_ID ||
      process.env.REACT_APP_GA_MEASUREMENT_ID ||
      process.env.REACT_APP_GOOGLE_ANALYTICS_ID
  );
  if (fromEnv) {
    return fromEnv;
  }
  if (typeof window !== 'undefined') {
    return normalizeGaId(window.__GA_MEASUREMENT_ID__);
  }
  return null;
};

/**
 * Inline script that exposes the runtime ID to the hydrated client.
 *
 * @param {string|null} id
 * @returns {string}
 */
export const gaMeasurementIdInlineScript = id => {
  const safe = normalizeGaId(id);
  if (!safe) {
    return '';
  }
  return `window.__GA_MEASUREMENT_ID__=${JSON.stringify(safe)};`;
};
